import { api } from '../../lib/api';

export const assetService = {
  // List all assets
  async getAssets() {
    const data = await api.get('/api/asset/list');
    return Array.isArray(data) ? data : [];
  },

  // Get asset details by ID
  async getAsset(id) {
    const data = await api.get(`/api/asset/showdetail/${id}`);
    return data || null;
  },

  // Create a new asset
  async createAsset(assetData) {
    return await api.post('/api/asset/add', assetData);
  },

  // Update an existing asset
  async updateAsset(id, assetData) {
    return await api.put(`/api/asset/update/${id}`, assetData);
  },

  // Delete an asset
  async deleteAsset(id) {
    return await api.delete(`/api/asset/delete/${id}`);
  },

  // Get assets by product ID
  async getAssetsByProduct(productId) {
    const data = await api.get(`/api/asset/by-product/${productId}`);
    return Array.isArray(data) ? data : [];
  },

  // Get assets by product ID
  async getAssetHierarchy(assetId) {
    return await api.get(`/api/asset/showHierarchi/${assetId}`);
  },
};
